import React, {Component, Fragment} from 'react';
import ReactModal from 'react-modal';

import {Input} from '../settings/Select';
import ButtonRow from '../common/ButtonRow';
import FlatButton from '../common/FlatButton';
import PrimaryFlatButton from '../common/PrimaryFlatButton';
import theme from '../../constants/theme';

ReactModal.setAppElement('#root');

class DescriptionModal extends Component {
  state = {
    description: '',
  };

  save = () => {
    const {save} = this.props;
    save(this.state.description);
  };

  handleChange = event => {
    this.setState({description: event.target.value});
  };

  render() {
    const {description} = this.state;

    const {isVisible, cancel} = this.props;
    return (
      <Fragment>
        <ReactModal
          isOpen={isVisible}
          contentLabel="Favoriten Beschreibung"
          onRequestClose={cancel}
          style={{
            overlay: {
              backgroundColor: theme.primaryColorOverlay,
            },
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              color: 'black',
              height: 150,
              width: 600,
            },
          }}>
          <Input
            type="text"
            placeholder="Beschreibung"
            value={description}
            onChange={this.handleChange}
            style={{width: '100%'}}
          />
          <ButtonRow>
            <FlatButton onClick={cancel}>Abbrechen</FlatButton>
            <PrimaryFlatButton dark disabled={description === ''} onClick={this.save}>
              Speichern
            </PrimaryFlatButton>
          </ButtonRow>
        </ReactModal>
      </Fragment>
    );
  }
}

export default DescriptionModal;
